var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEdit = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.54762 1.45281L6.54719 3.45238L2.20438 7.79518L0.423519 7.99826C0.298546 8.00868 0.194402 7.97223 0.111087 7.88891C0.0277718 7.8056 -0.00867867 7.70145 0.00173573 7.57648L0.204817 5.79562L4.54762 1.45281ZM7.7813 1.156C7.9271 1.3018 8 1.47885 8 1.68713C8 1.89542 7.9271 2.07247 7.7813 2.21827L6.89087 3.1087L4.8913 1.10913L5.78173 0.218703C5.92753 0.0729008 6.10458 0 6.31287 0C6.52115 0 6.6982 0.0729008 6.844 0.218703L7.7813 1.156Z",
    fill: "#7F7F7F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit.26858b4c.svg";
export { ForwardRef as ReactComponent };